// extracted by mini-css-extract-plugin
export var circle = "_47-2";
export var icon = "_47-a";
export var iconHighlight = "_47-0";
export var lg = "_47-8";
export var md = "_47-7";
export var outline = "_47-4";
export var sm = "_47-6";
export var square = "_47-1";
export var xl = "_47-9";
export var xs = "_47-5";
export var xxs = "_47-3";